/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Form, Formik } from "formik";
import React from "react";
import TaxPersonalTable from "./components/table";
import initialValues from "./schema/initialValues";
import validation from "./schema/validations";
import form from "./schema/form";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Loading from "components/Common/Loading";
import SwitchField from "components/SwitchField";
import SelectField from "components/SelectField";
import { useEffect, useState } from "react";
import Tabs from "./components/tabs";
import Actions from "./components/actions";
import ModalCommon from "components/Modal";
import ModalContent from "./components/modalContent";
import Fields2 from "./components/field2";
import form2 from "./schema/form2";
import initialValues2 from "./schema/initialValues2";
import validation2 from "./schema/validations2";
import Table2 from "./components/table2";
import Fields3 from "./components/field3";
import form3 from "./schema/form3";
import initialValues3 from "./schema/initialValues3";
import validation3 from "./schema/validations3";
import Table3 from "./components/table3";
import Fields4 from "./components/field4";
import form4 from "./schema/form4";
import initialValues4 from "./schema/initialValues4";
import validation4 from "./schema/validations4";
import Table4 from "./components/table4";
import Fields5 from "./components/field5";
import form5 from "./schema/form5";
import initialValues5 from "./schema/initialValues5";
import validation5 from "./schema/validations5";
import Table5 from "./components/table5";

export default function FinancialReport17() {
  const { formId, formField } = form;
  const { formId2, formField2 } = form2;
  const { formId3, formField3 } = form3;
  const { formId4, formField4 } = form4;
  const { formId5, formField5 } = form5;

  const [open, setOpen] = React.useState(true);
  const [tab, setTab] = React.useState(0);
  const [pickAll, setPickAll] = React.useState(false);

  const [list, setList] = React.useState([
    { name: "BCKQHĐKD", checked: false },
    { name: "LCTTTT", checked: false },
    { name: "LCTTGT", checked: false },
    { name: "BCTHBDVCSH", checked: false },
  ]);
  const handleChangeSwitch = (name, checked) => {
    if (pickAll) return;
    setList((prev) =>
      prev.map((item) => {
        if (item.name === name) {
          return { ...item, checked };
        }
        return item;
      })
    );
  };
  const handleSubmit = async (values, action) => {
    console.log({ values });
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!open && (
        <>
          <Tabs tab={tab} setTab={setTab} list={list} pickAll={pickAll} />
          <Actions
            list={list}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        </>
      )}
      <ModalCommon
        open={open}
        setOpen={setOpen}
        content={
          <ModalContent
            list={list}
            setList={setList}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        }
      >
        {tab === 0 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Báo cáo tình hình tài chính riêng (Mẫu số B01 - CTCK)
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Ban hành theo TT số 334/2016/TT-BTC ngày 27/12/2016 của Bộ Tài chính)
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                Tại ngày 31 tháng 12 năm 2022
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues}
              validationSchema={validation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <Fields
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                  />
                  <TaxPersonalTable
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 1 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Báo cáo kết quả hoạt động riêng (Mẫu số B02-CTCK)
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Ban hành theo TT số 334/2016/TT-BTC ngày 27/12/2016 của Bộ Tài Chính)
              </Typography>
              <Typography variant="subtitle1" fontSize={14}>
                Năm 2022
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues2}
              validationSchema={validation2}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId2} autoComplete="off">
                  <Fields2
                    formData={{
                      values,
                      touched,
                      formField2,
                      errors,
                    }}
                  />
                  <Table2
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Lưu"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 2 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Báo cáo lưu chuyển tiền tệ riêng (Mẫu số B03a-CTCK)
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Theo phương pháp trực tiếp)
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Ban hành theo TT số 334/2016/TT-BTC ngày 27/12/2016 của Bộ Tài Chính)
              </Typography>
              <Typography variant="subtitle1" fontSize={14}>
                Năm 2022
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues3}
              validationSchema={validation3}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId3} autoComplete="off">
                  <Fields3
                    formData={{
                      values,
                      touched,
                      formField3,
                      errors,
                    }}
                  />
                  <Table3
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 3 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Báo cáo lưu chuyển tiền tệ riêng (Mẫu số B03b-CTCK)
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Theo phương pháp gián tiếp)
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Ban hành theo TT số 334/2016/TT-BTC ngày 27/12/2016 của Bộ Tài Chính)
              </Typography>
              <Typography variant="subtitle1" fontSize={14}>
                Năm 2022
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues4}
              validationSchema={validation4}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId4} autoComplete="off">
                  <Fields4
                    formData={{
                      values,
                      touched,
                      formField4,
                      errors,
                    }}
                  />
                  <Table4
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 4 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Báo cáo tình hình biến động vốn chủ sở hữu (Mẫu số B04-CTCK)
              </Typography>

              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Ban hành theo TT số 334/2016/TT-BTC ngày 27/12/2016 của Bộ Tài Chính)
              </Typography>
              <Typography variant="subtitle1" fontSize={14}>
                Năm 2022
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues5}
              validationSchema={validation5}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId5} autoComplete="off">
                  <Fields5
                    formData={{
                      values,
                      touched,
                      formField5,
                      errors,
                    }}
                  />
                  <Table5
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
      </ModalCommon>
    </DashboardLayout>
  );
}
const auditOpinionOption = [
  { value: "Ý kiến trái ngược", label: "Ý kiến trái ngược" },
  { value: "Ý kiến từ chối đưa ra ý kiến", label: "Ý kiến từ chối đưa ra ý kiến" },
  { value: "Ý kiến ngoại trừ", label: "Ý kiến ngoại trừ" },
  { value: "Ý kiến chấp nhận toàn phần", label: "Ý kiến chấp nhận toàn phần" },
];
function Fields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const {
    taxpayersName,
    taxpayersId,

    taxAgentName,
    taxAgentId,

    tctm,
    bctc,
    htldl,
    auditOpinion,
  } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxpayersName.name}
            label={taxpayersName.label}
            value={values.taxpayersName}
            error={errors.taxpayersName && touched.taxpayersName}
            success={values.taxpayersName?.toString().length > 0 && !errors.taxpayersName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxpayersId.name}
            label={taxpayersId.label}
            value={values.taxpayersId}
            error={errors.taxpayersId && touched.taxpayersId}
            success={values.taxpayersId?.toString().length > 0 && !errors.taxpayersId}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgentName.name}
            label={taxAgentName.label}
            value={values.taxAgentName}
            error={errors.taxAgentName && touched.taxAgentName}
            success={values.taxAgentName?.toString().length > 0 && !errors.taxAgentName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgentId.name}
            label={taxAgentId.label}
            value={values.taxAgentId}
            error={errors.taxAgentId && touched.taxAgentId}
            success={values.taxAgentId?.toString().length > 0 && !errors.taxAgentId}
          />
        </Grid>
        <Grid item xs={3} style={{ paddingTop: 0 }}>
          <SwitchField name={bctc.name} label={bctc.label} value={values.bctc} />
        </Grid>
        <Grid item xs={3} style={{ paddingTop: 0 }}>
          <SwitchField name={htldl.name} label={htldl.label} value={values.htldl} />
        </Grid>
        <Grid item xs={3} style={{ paddingTop: 0 }}>
          <SwitchField name={tctm.name} label={tctm.label} value={values.tctm} />
        </Grid>
        <Grid item xs={3} style={{ paddingTop: 0 }}>
          <SelectField
            options={auditOpinionOption}
            type={auditOpinion.type}
            label={auditOpinion.label}
            name={auditOpinion.name}
            value={values.auditOpinion}
            placeholder={auditOpinion.placeholder}
            error={errors.auditOpinion && touched.auditOpinion}
            success={values.auditOpinion.length > 0 && !errors.auditOpinion}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
